import { Component, Input, computed, signal } from '@angular/core';
import { BillboardImageWidget, Theme } from '../../models/reader-document';

@Component({
  selector: 'wr-billboard-image-widget',
  standalone: true,
  template: `
    <div
        class="wr-billboard-image-widget"
      [style.background]="background()"
    >
      @if (imageSrc()) {
        @if (linkUrl()) {
          <a
            [href]="linkUrl()!"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              [src]="imageSrc()!"
              [alt]="altText()"
              class="w-full block hover:opacity-80 duration-400 ease-in-out"
              (error)="onImgError($event)"
            />
          </a>
        } @else {
          <img
            [src]="imageSrc()!"
            [alt]="altText()"
            class="w-full block"
            (error)="onImgError($event)"
          />
        }
      }
    </div>
  `,
})
export class BillboardImageWidgetComponent {
  private widgetSig = signal<BillboardImageWidget | null>(null);
  private themeSig = signal<Theme | null>(null);
  private imgSrcSig = signal<string | null>(null);

  @Input() set json(value: BillboardImageWidget) {
    this.widgetSig.set(value);

    const primary = value?.url || null;
    const fallback = value?.fallbackUrl || null;
    this.imgSrcSig.set(primary || fallback);
  }

  @Input() set theme(value: Theme | undefined) {
    this.themeSig.set(value ?? null);
  }

  widget = computed(() => this.widgetSig());

  imageSrc = computed(() => this.imgSrcSig());

  linkUrl = computed(() => this.widget()?.linkURL || null);

  altText = computed(
    () =>
      this.widget()?.altTitle ??
      this.widget()?.name ??
      this.widget()?.id ??
      'billboard image'
  );

  // TODO: Remove?
  background = computed(
    () => this.widget()?.style?.['background'] ?? 'transparent'
  );

  onImgError(_: Event) {
    const w = this.widget();
    if (!w?.fallbackUrl) return;

    if (this.imgSrcSig() !== w.fallbackUrl) {
      this.imgSrcSig.set(w.fallbackUrl);
    }
  }
}
